import { notification } from "antd";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import Loading from "shared/components/Spin";
import { useMutation, useQuery } from "shared/hooks/useApi";
import { NAME_SPACES } from "shared/locales/constants";
import { DELETE_EMAIL_TEMPLATE } from "utils/api/graphql/mutations/email";
import {
  GET_EMAIL_TEMPLATE,
  GET_EMAIL_TEMPLATES,
} from "utils/api/graphql/queries/emailTemplate";
import { SCREENS } from "utils/constants";

const Delete = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.EMAIL_TEMPLATE);
  const DELETE = t("DELETE", { returnObjects: true });

  const { data, loading } = useQuery(GET_EMAIL_TEMPLATE, {
    variables: { where: { id } },
  });

  const [deleteEmailTemplate] = useMutation(DELETE_EMAIL_TEMPLATE, {
    refetchQueries: [
      {
        query: GET_EMAIL_TEMPLATES,
        awaitRefetchQueries: true,
      },
    ],
    onCompleted: () => {
      notification.success({
        message: DELETE.SUCCESS,
        closeIcon: null,
      });
      navigate(SCREENS.PRIVATE.ADMIN.EMAIL_TEMPLATES.LIST.path);
    },
  });

  const handleDelete = () => {
    deleteEmailTemplate({ variables: { where: { id } } });
  };

  const handleCancel = () => {
    navigate(SCREENS.PRIVATE.ADMIN.EMAIL_TEMPLATES.LIST.path);
  };

  if (loading) return <Loading />;

  return (
    <div className="d-flex flex--column align--center justify--center p-40">
      <h2>{DELETE.TITLE}</h2>
      <p className="mt-16">
        {DELETE.CONFIRM} <strong>{data?.emailTemplate?.label}</strong> ?
      </p>
      <div className="d-flex gap-16 mt-24">
        <button
          className="email-composer__btn email-composer__btn--cancel"
          onClick={handleCancel}
        >
          {DELETE.CANCEL}
        </button>
        <button
          className="email-composer__btn email-composer__btn--send"
          onClick={handleDelete}
        >
          {DELETE.SUBMIT}
        </button>
      </div>
    </div>
  );
};

export default Delete;
